import React from 'react'
import { Table, TableContainer } from '@mui/material'
import { Head } from './Head'
import { Body } from './Body'
import { Actions, Field, Pager, Search, Sort } from './types'
import { useIsOpenMenuLeftContext } from '../../common/utils/isOpenMenuLeftContext'
import styles from './AppTable.module.css'

const DEFAULT_ROW_KEY = 'id'

export type TableProps<T, Q> = {
  readonly fields: Field<T>[]
  readonly items: T[]
  readonly rowKeyField: keyof T
  readonly actions?: Actions<T>
  readonly search?: Search<Q>
  readonly sort?: Sort<T>
  readonly pager?: Pager
  readonly isLoading?: boolean
}

export function AppTable<T extends { [key: string]: any }, Q extends { [key: string]: any }>(
  props: TableProps<T, Q>
) {
  const { openMenuLeft } = useIsOpenMenuLeftContext()

  return (
    <>
      <TableContainer
        className={`${styles.tableContainer} ${
          openMenuLeft ? styles.tableContainerOpen : styles.tableContainerClosed
        }`}
      >
        {/* Head y Body cuelgan directamente de Table: un <div> entre medias no es
            HTML valido (table solo admite thead/tbody/tfoot/caption/colgroup) y
            React lo avisaba con validateDOMNesting. El div que habia aqui no
            aportaba estilo ninguno: sus clases (tableInner/tableInnerOpen/
            tableInnerClosed) nunca llegaron a existir en AppTable.module.css. */}
        <Table className={styles.table}>
          <Head fields={props.fields} sort={props.sort} actions={props.actions} />
          <Body
            actions={props.actions}
            fields={props.fields}
            items={props.items}
            rowKeyField={props.rowKeyField || DEFAULT_ROW_KEY}
            isLoading={props.isLoading}
          />
        </Table>
      </TableContainer>
    </>
  )
}
